import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Customer} from '../../model/Entities/Customer';

@Component({
    selector: 'contract-state-change-confirm-dialog',
    templateUrl: './contract-state-change-confirm.dialog.component.html',
    styleUrls: ['./contract-state-change-confirm.dialog.component.scss']
})
export class ContractStateChangeConfirmDialogComponent {
    public direction = 'out';

    constructor(public dialog: MatDialogRef<ContractStateChangeConfirmDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.direction = data.direction;
    }
}



// WEBPACK FOOTER //
// /app/src/ContractsModule/ContractStateChangeConfirmDialogComponent/contract-state-change-confirm.dialog.component.ts